import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import UsuarioEmpresaAgencia from './UsuarioEmpresaAgencia';
import cadastrarUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/cadastrarUsuariosEmpresaAgencia';
import buscarUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/buscarUsuariosEmpresaAgencia';
import {showSuccessMsg} from '../../../util/messagesUtil';

export const CabecalhoTabela = () => (
  <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', gap: '8px', padding: '8px 12px', fontWeight: '600', fontSize: '12px', borderBottom: '2px solid #FF6A00', marginTop: '16px' }}>
    <div>Agência</div>
    <div>Ações</div>
  </div>
);


export class ModalRelacionarAgenciaUsuario extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      agenciaSelecionada: null
    };

  }

  submit () {
    this.props.cadastrarUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.usuarioEmpresaId, this.state.agenciaSelecionada.value)
      .then(() => {
          showSuccessMsg('Agência vinculada com sucesso');
          this.props.buscarUsuario()
          this.props.buscarUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.usuarioEmpresaId)
          this.limpar();
      })
  }

  exibirComboAgencias (event) {
    let idsAgenciasUsuario = [];
    if(this.props.usuariosEmpresaAgencia && this.props.usuariosEmpresaAgencia.length){
      idsAgenciasUsuario = this.props.usuariosEmpresaAgencia.map(uea => uea.agenciaId);
    }

    return (
      <div>
        <Select
          {...event.input}
          noOptionsMessage={() => ('Nenhuma opção encontrada')}
          placeholder='Selecione uma agência...'
          options={this.props.agencias.filter(agencia => !idsAgenciasUsuario.includes(agencia.id)).map(elemento => (
            {
              label: elemento.nomeComNumero,
              value: elemento.id
            }))}
          onChange={value => this.setState({agenciaSelecionada: value})}
          value={this.state.agenciaSelecionada}
        />
      </div>
    )
  }

  exibirAgenciasUsuario () {
    if (!this.props.usuariosEmpresaAgencia || !this.props.usuariosEmpresaAgencia.length) {
      return <div className='col-12'>
        <div className="mt-2 alert alert-warning text-center" role="alert">
          Não existem agências cadastradas para o usuário.
        </div>
      </div>
    }
    return <React.Fragment>
      <CabecalhoTabela/>
      {this.props.usuariosEmpresaAgencia
        .map((usuarioEmpresaAgencia, index) => <UsuarioEmpresaAgencia
          key={index}
          usuarioEmpresaAgencia={usuarioEmpresaAgencia}
          buscarUsuario={this.props.buscarUsuario}
          indice={index}/>)}
    </React.Fragment>
  }


  limpar () {
    this.setState({ agenciaSelecionada: null })
  }

  render () {
    const {
      handleSubmit, submitting
    } = this.props;
    return (
      <div className="modal fade show" id='modalRelacionarAgenciaUsuario' role='dialog'
           aria-labelledby='modalRelacionarAgenciaUsuario' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-icon">
                <i className="material-icons">store</i>
              </div>
              <div>
                <h5 className="vx-modal-title">Relacionar Agência</h5>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                      onClick={() => this.limpar()}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <div className="vx-modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className='col-10 col-sm-10 col-md-8'>
                  <label>Agência</label>
                  <Field name='rota' component={this.exibirComboAgencias.bind(this)}/>
                </div>
                <div className='col-10 col-sm-10 col-md-8' style={{ marginTop: '12px' }}>
                  <button id="btn-salvar"
                          type="submit" disabled={submitting || !this.state.agenciaSelecionada}
                          className="vx-btn-primary">Incluir
                  </button>
                </div>
              </form>
              {this.exibirAgenciasUsuario()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    usuarioSelecionado: state.usuarioSelecionado,
    agencias: state.agencias.agencias,
    usuariosEmpresaAgencia: state.usuariosEmpresaAgencia
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarUsuariosEmpresaAgencia,
    buscarUsuariosEmpresaAgencia,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formRelacionarAgenciaUsuario'
})(ModalRelacionarAgenciaUsuario));
